import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { animeGuideSteps } from '@/mocks/animeData';

export default function GuideSection() {
  return (
    <section id="guide" className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Guide"
            title="追番观看指南"
            description="第一次来、或者只是想高效找到想看的那一部，按这四步走一遍就够了，不用在页面上反复摸索。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {animeGuideSteps.map((step, index) => (
            <Reveal key={step.title} delay={index * 70}>
              <div className="relative h-full rounded-lg bg-background-50 border border-background-200/70 p-5">
                <span className="absolute top-4 right-4 font-heading text-3xl font-black text-background-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {step.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="md:col-span-2 rounded-lg bg-primary-500 text-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2">
                <i className="ri-flashlight-fill text-accent-300"></i>
                <h3 className="font-heading text-lg font-bold">小提示：怎么选得更快</h3>
              </div>
              <p className="mt-3 text-xs md:text-sm text-background-100 leading-relaxed">
                时间紧张时，优先看“完结 / 全集”标签的作品，一次看完不用等；想跟热点就顺着热播榜往下挑；
                只想放松，则从“日常治愈”类型里选一两部，节奏更慢、负担更轻。三种挑法对应不同的观看场景。
              </p>
            </div>
            <div className="rounded-lg bg-accent-100 border border-accent-300/60 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-accent-900">按状态快速分流</h3>
              <ul className="mt-3 space-y-2 text-xs md:text-sm text-accent-900">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-600"></i>
                  想一次看完 → 完结
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-600"></i>
                  想跟更新 → 更新中
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-accent-600"></i>
                  想追当季 → 新番
                </li>
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}